import { Check } from "lucide-react";
import { Link } from "react-router-dom";

// Rotalie Logo Component - Default dark text
export const RotalieLogo = ({ className = "", size = "default", showText = true }) => {
  const sizes = {
    small: { icon: "w-8 h-8", check: "w-4 h-4", text: "text-lg", tabs: "w-1 h-1.5" },
    default: { icon: "w-10 h-10", check: "w-5 h-5", text: "text-xl", tabs: "w-1.5 h-2" },
    large: { icon: "w-12 h-12", check: "w-6 h-6", text: "text-2xl", tabs: "w-2 h-2.5" }
  };
  const s = sizes[size] || sizes.default;
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${s.icon} rounded-xl bg-gradient-to-br from-violet-500 to-teal-400 flex items-center justify-center relative`}>
        {/* Calendar tabs */}
        <div className={`absolute -top-0.5 left-1/4 ${s.tabs} bg-gradient-to-b from-violet-500 to-violet-400 rounded-t-sm`} />
        <div className={`absolute -top-0.5 right-1/4 ${s.tabs} bg-gradient-to-b from-violet-500 to-violet-400 rounded-t-sm`} />
        <Check className={`${s.check} text-white stroke-[3]`} />
      </div>
      {showText && (
        <span className={`${s.text} font-bold text-slate-900 font-['Inter']`}>Rotalie</span>
      )}
    </div>
  );
};

// Logo for dark backgrounds (white text)
export const RotalieLogoLight = ({ className = "", size = "default", showText = true }) => {
  const sizes = {
    small: { icon: "w-8 h-8", check: "w-4 h-4", text: "text-lg", tabs: "w-1 h-1.5" },
    default: { icon: "w-10 h-10", check: "w-5 h-5", text: "text-xl", tabs: "w-1.5 h-2" },
    large: { icon: "w-12 h-12", check: "w-6 h-6", text: "text-2xl", tabs: "w-2 h-2.5" }
  };
  const s = sizes[size] || sizes.default;
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${s.icon} rounded-xl bg-gradient-to-br from-violet-500 to-teal-400 flex items-center justify-center relative`}>
        <div className={`absolute -top-0.5 left-1/4 ${s.tabs} bg-gradient-to-b from-violet-400 to-violet-300 rounded-t-sm`} />
        <div className={`absolute -top-0.5 right-1/4 ${s.tabs} bg-gradient-to-b from-violet-400 to-violet-300 rounded-t-sm`} />
        <Check className={`${s.check} text-white stroke-[3]`} />
      </div>
      {showText && (
        <span className={`${s.text} font-bold text-white font-['Inter']`}>Rotalie</span>
      )}
    </div>
  );
};

// Logo with Link wrapper
export const RotalieLogoLink = ({ to = "/", className = "", size = "default" }) => (
  <Link to={to} className={className}>
    <RotalieLogo size={size} />
  </Link>
);

export default RotalieLogo;
